import { Component } from '@angular/core';

@Component({
  selector: 'app-refund-policy',
  templateUrl: './refund-policy.html',
  styleUrl: './refund-policy.scss'
})
export class RefundPolicy {
}
